import { render, staticRenderFns } from "./CustomVoucherEditor.vue?vue&type=template&id=3c48ca1f&scoped=true&"
import script from "./CustomVoucherEditor.vue?vue&type=script&lang=js&"
export * from "./CustomVoucherEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c48ca1f",
  null
  
)

export default component.exports